// src/auth/screens/BootSpinner.jsx
import React from 'react';
import { useTranslation } from 'react-i18next';
import { COLORS, FONT_SANS } from '../../constants/theme.js';

export default function BootSpinner() {
  const { t } = useTranslation('auth');
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', background: COLORS.bg }}>
      <div style={{ color: COLORS.textTertiary, fontFamily: FONT_SANS, fontSize: '14px' }}>
        {t('boot.loading')}
      </div>
    </div>
  );
}
